// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import FlagIcon from 'vue-flag-icon'
import VueProgressBar from 'vue-progressbar'
import * as VueGoogleMaps from 'vue2-google-maps'

import router from './router'
import i18n from './lang'
import store from './store'
import * as svgicon from 'vue-svgicon'
import progressbarOptions from './mixins/progressBarOptions'
import googlemapsOptions from './mixins/googlemapsOptions'

import 'normalize.css'
import 'font-awesome-webpack'

Vue.config.productionTip = process.env.NODE_ENV === 'production'

Vue.use(FlagIcon)
Vue.use(svgicon)
Vue.use(VueProgressBar, progressbarOptions)
Vue.use(VueGoogleMaps, googlemapsOptions)

store.commit('setApiBase', process.env.API_URL)
store.commit('setApiSecret', process.env.API_SECRET)
store.commit('setApiID', process.env.API_ID)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App },
  created () {
    this.$Progress.start()
  }
})



// WEBPACK FOOTER //
// ./src/main.js